
import React,{useState} from 'react'
import { Button } from 'primereact/button'
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik'
import * as Yup from 'yup';
import axios from 'axios';
import appUrl from "../../../../constants/appUrl";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddEditFaq = ({editable,setRes,rowData,setDialog,onHide}) => {
    const [apiRes, setApiRes] = useState();

    const validationSchema = Yup.object({
        question: Yup.string().required('Required'),
        answer: Yup.string().required('Required'),

    });
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            question:  '',
            answer:  '',

        },

        onSubmit: async (data) => {
            try {
              if (editable) {
                const response = await axios.patch(`${appUrl.baseUrl}api/OutageDegradation/UpdateOutageDegradation`, data);
                setApiRes(response);
               
                setRes(response);
              } else {
                const response = await axios.post(`${appUrl.baseUrl}api/FAQ/AddNewFAQ`, data);
                setApiRes(response);
                toast.success("Add Succesfully")
                setRes(response);
                setDialog(false);
              }
      
              setDialog(false);
            } catch (error) {
              // Handle error if needed
            } finally {
              console.log('Submitting form and hiding dialog');
              onHide(); 
          
            }
          },
        });
    return (<>
            <ToastContainer />
   
        <form onSubmit={formik.handleSubmit}>
            <div className="p-fluid formgrid grid">

                <div className="field  md:col-4">
                    <label htmlFor="" style={{ fontWeight: "bold" }}>Question <span className='Staric-Custom'> *</span></label>
                    <InputText
                        id="question"
                        name="question"
                        type="text"
                        value={formik.values.question}
                        onChange={formik.handleChange}
                    />
                    {formik.touched.question && formik.errors.question ? <div className='error'>{formik.errors.question}</div> : null}
                </div>

                <div className="field md:col-4">
                    <label htmlFor="" style={{ fontWeight: "bold" }}>Answer <span className='Staric-Custom'> *</span></label>
                    <InputText
                        id="answer"
                        name="answer"
                        type="text"
                        value={formik.values.answer}
                        onChange={formik.handleChange}
                    />
                    {formik.touched.answer && formik.errors.answer ? <div className='error'>{formik.errors.answer}</div> : null}
                </div>


                <div className="col-12 md:col-10"></div>
                <div className="col-12 md:col-2" >
                    <div className="flex justify-content-center">
                        <Button className="custom-bg" label={editable ? 'Update' : 'Add '} type='submit' />
                    </div>
                </div>

            </div>


        </form>
        </>
    )
}

export default AddEditFaq